import React from 'react';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import Crown from '../svg/crown';
import { Icon } from '../icon';

interface _ButtonActionsProps {
    $disabled?: boolean;
    $selected?: boolean;
}

const _ButtonActions = styled.div<_ButtonActionsProps>`
    font-size: 12px;
    border-radius: 3px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    padding: 8px;
    gap: 8px;
    color: ${(props) => props.theme.app.textColor} !important;

    ${(props) =>
        props.$selected &&
        `
        color: ${props.theme.app.secondary};
    `}

    ${(props) => props.$disabled && `opacity: ${props.theme.app.disabledOpacity};`}

	&:hover {
        background-color: #f6f8f9;
        cursor: pointer;
    }
`;

interface ButtonActionsProps {
    disabled?: boolean;
    selected?: boolean;
    requireUpgrade?: boolean;
    onClick: () => void;
}

export const ButtonActions: FC<PropsWithChildren<ButtonActionsProps>> = ({ disabled, selected, requireUpgrade, onClick, children }) => {
    return (
        <_ButtonActions $selected={selected} $disabled={disabled} onClick={() => !disabled && onClick && onClick()}>
            {children}
            {requireUpgrade && (
                <Icon>
                    <Crown className='Upgrade'></Crown>
                </Icon>
            )}
        </_ButtonActions>
    );
};

export const ButtonActionsDelete = styled.div`
    font-size: 12px;
    border-radius: 3px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 0.5rem;
    color: red;
    &:hover {
        background-color: #f6f8f9;
        cursor: pointer;
    }
`;
